import React from "react";
import {
  defineBlock,
  smartProps,
  useInspectorControl,
  useSmartProp,
} from "@smartfire/gutenberg-react";
import {
  PanelBody,
  PanelRow,
  TextControl,
  ColorPalette,
} from "@wordpress/components";
import style from "./block.module.scss";

function Inspector() {
  const [height, setHeight] = useSmartProp("height");
  const [color, setColor] = useSmartProp("color");

  const colors = [
    { label: "Vert", color: style.greenBouton },
    { label: "Vert clair", color: style.lightGreen },
    { label: "Vert foncé", color: style.darkGreen },
    { label: "Bleu", color: style.blue },
    { label: "Orange", color: style.darkOrange },
    { label: "Gris", color: style.grey },
    { label: "Gris clair", color: style.lightGrey },
    { label: "Blanc", color: "#fff" },
  ];

  return (
    <>
      <PanelBody title="Configuration Hauteur" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Hauteur du séparateur (px)"}
            value={height}
            onChange={(value) => setHeight(value)}
          />
        </PanelRow>
      </PanelBody>
      <PanelBody title="Couleur de fond" initialOpen={true}>
        <PanelRow>
          <ColorPalette
            label={"Couleur de fond"}
            colors={colors}
            value={color}
            onChange={(color) => setColor(color)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}
function Block({ height, color }) {
  useInspectorControl(Inspector);

  return (
    <div
      className={style.block}
      style={{ backgroundColor: color, height: height + "px" }}
    ></div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    height: smartProps.string.withDefault(50),
    color: smartProps.string.withDefault(""),
  },
  setup: {
    title: "Séparateur",
  },
});
